export function getRadianAngle(degreeValue: number) {
  return (degreeValue * Math.PI) / 180;
}
